import styled from "@emotion/styled";
import { Popover } from "react-aria-components";

export const MDSMenuDropdownPopover = styled(Popover)`
  padding-block: ${({ theme }) => theme.spacing[3]};
  background: ${({ theme }) => theme.colors.surface.menu};
  border: 1px solid ${({ theme }) => theme.colors.border.surface};
  box-shadow: ${({ theme }) => theme.shadows.surface};
  border-radius: ${({ theme }) => theme.borderRadius.large};

  width: max-content;
  max-width: 90vw;
  max-height: inherit;
  overflow-y: auto;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
`;
